module.exports = __webpack_public_path__ + "img/eth.7fe75c25.svg";